// extracted by mini-css-extract-plugin
export default {"paymentList":"oDZkD"};